<template>
  <Collapsible :forceOpen="datePickerOpen">
  <div slot="header" class="container">
    <div class="button-group noselect">
      <span class="button button-icon button-left" @click.stop="onPrev()"><i class="material-icons bold">navigate_before</i></span><!--
      --><span class="button button-middle" @click.stop="onDateToggle()" >{{displayDate}}</span><!--
      --><span class="button button-icon button-right" @click.stop="onNext()"><i class="material-icons bold">navigate_next</i></span>
    </div>
  </div>
  <div class="noselect date-wrap">
    <datepicker
      :value="date"
      :monday-first="true"
      :inline="true"
      :language="lang"
      @selected="onDateSelect($event)"></datepicker>
  </div>
  </Collapsible>

</template>

<script>

import datepicker from 'vuejs-datepicker';
import fi from './../utils/fi'

import TimeUtils from '../utils/TimeUtils'
import Collapsible from '@/components/Collapsible'

export default {
  name: 'DateSelectGadget',
  components: { Collapsible, datepicker },
  props: ['date', 'week'],
  data () {
    return {
      lang: fi,
      datePickerOpen: false
    }
  },
  methods: {
    onDateToggle () {
      this.datePickerOpen = !this.datePickerOpen;
    },
    onDateSelect (date) {
      this.$emit('update', TimeUtils.toISO(date));
      this.datePickerOpen = false;
    },
    onPrev () {
      if (this.week) {
        const newDate = TimeUtils.addDays(this.date, -7);
        this.$emit('update', newDate);
      } else {
        const newDate = TimeUtils.addDays(this.date, -1);
        this.$emit('update', newDate);
      }
    },
    onNext () {
      if (this.week) {
        const newDate = TimeUtils.addDays(this.date, 7);
        this.$emit('update', newDate)
      } else {
        const newDate = TimeUtils.addDays(this.date, 1);
        this.$emit('update', newDate)
      }
    },
    getWeekText (date) {
      const TU = TimeUtils;
      const monday = TU.dateToWeek(date);
      const sunday = TU.addDays(monday, 6);
      return `${TU.toShortFIN(monday)} - ${TU.toFIN(sunday)} (vko ${TU.getWeekNumber(date)})`
    },
    getDayText (date) {
      const TU = TimeUtils;
      return `${TU.getWeekDay(this.date, this.lang.days)} ${TU.toFIN(this.date)} (vko ${TU.getWeekNumber(date)})`;
    }
  },
  computed: {
    displayDate () {
      if (this.week) {
        return this.getWeekText(this.date);
      } else {
        return this.getDayText(this.date);
      }
    }
  },
  beforeMount () {
    const self = this;
    const refreshTime = 8 * 60 * 60 * 1000; // 8 hours

    let blurTime = new Date();
    window.onfocus = function () {
      if (blurTime && (new Date().valueOf() - blurTime.valueOf()) > refreshTime) {
        self.onDateSelect(new Date());
      }
      blurTime = null;
    };
    window.onblur = function () {
      blurTime = new Date();
    };
  },
}
</script>

<style lang="scss" scoped>

  @import 'src/color.scss';
  @import 'src/values.scss';

  $height: 2em;
  $radius: 0.0em;

  .container {
    display: inline-block;
    width: 100%;
    height: 2.5em;
    margin: 0;
  }

  .button-group {
    display: table;
    width: 100%;
    height: 100%;
  }

  .button {
    color: $secondary-text;
    padding: 0;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    //background: -webkit-linear-gradient($secondary-light, $secondary 120%);
    background: $secondary;
    //border: 1px solid $secondary-dark;
    // width: 1%;
    font-weight: bold;
    cursor: pointer;

    transition: $transition-time all;
    &:hover {
      background-color: $secondary-dark;
    }
  }

  .button:hover {
    border-color: $secondary;
  }
  .button:focus {
    border-color: $secondary-dark
  }

  .button-left {
    border-top-left-radius: $radius;
    border-bottom-left-radius: $radius;
  }

  .button-middle {
    border-left: none;
    border-right: none;
    text-transform: capitalize;
  }

  .button-right {
    border-top-right-radius: $radius;
    border-bottom-right-radius: $radius;
  }

  .button-icon {
    width: 14%;
  }

  .bold {
    font-weight: bold;
  }

  .date-wrap {
    background: white;
  }

</style>



// WEBPACK FOOTER //
// src/components/DateSelectGadget.vue